import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueRouter from 'vue-router'
import { sync } from 'vuex-router-sync'

import Vuebar from 'vuebar'
import VueVimeoPlayer from 'vue-vimeo-player'

import store from './store'
import routes from './routes'
import AppComponent from './components/App.vue'

import './directives/Longpress'

Vue.use(Vuebar)
Vue.use(VueRouter)
Vue.use(VueMeta, { refreshOnceOnNavigation: false })
Vue.use(VueVimeoPlayer)

export default ({ initialState = {}, apiUrl }) => {
  const router = new VueRouter({
    mode: 'history',
    scrollBehavior: (to, from, savedPosition) => {
      return new Promise((resolve, reject) => {
        setTimeout(() => resolve({ x: 0, y: 0 }), 250)
      })
    },
    routes
  })

  store.commit('mergeState', initialState)

  sync(store, router)

  const app = new Vue({
    render: h => h(AppComponent),
    store,
    router
  })

  return {
    app,
    router,
    store
  }
}
